// extracted by mini-css-extract-plugin
var _1 = "styles-module__control____IVyZ";
var _2 = "styles-module__isMapExpanded___bDFJ2";
export { _1 as "control", _2 as "isMapExpanded" }
